/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit všechny produkty`
};

const da_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Se alle produkter`
};

const de_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Alle Produkte anzeigen`
};

const en_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `View all products`
};

const es_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Ver todos los productos`
};

const fr_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Voir tous les produits`
};

const hu_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Összes termék megtekintése`
};

const it_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi tutti i prodotti`
};

const nl_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijk alle producten`
};

const pl_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Zobacz wszystkie produkty`
};

const pt_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Ver todos os produtos`
};

const sv_view_all_products = /** @type {(inputs: {}) => string} */ () => {
	return `Visa alla produkter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const view_all_products = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.view_all_products(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("view_all_products", locale)
	if (locale === "cs") return cs_view_all_products(inputs)
	if (locale === "da") return da_view_all_products(inputs)
	if (locale === "de") return de_view_all_products(inputs)
	if (locale === "en") return en_view_all_products(inputs)
	if (locale === "es") return es_view_all_products(inputs)
	if (locale === "fr") return fr_view_all_products(inputs)
	if (locale === "hu") return hu_view_all_products(inputs)
	if (locale === "it") return it_view_all_products(inputs)
	if (locale === "nl") return nl_view_all_products(inputs)
	if (locale === "pl") return pl_view_all_products(inputs)
	if (locale === "pt") return pt_view_all_products(inputs)
	return sv_view_all_products(inputs)
};